export const imageDataToDataUrl = (
  imageData: ImageData,
  format: 'image/jpeg' | 'image/png' = 'image/jpeg',
): string | null => {
  if (imageData.width <= 0 || imageData.height <= 0) {
    return null;
  }

  try {
    const canvas = document.createElement('canvas');
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    const context = canvas.getContext('2d');
    if (!context) {
      return null;
    }
    context.putImageData(imageData, 0, 0);
    return canvas.toDataURL(format);
  } catch {
    return null;
  }
};
